import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const TermsPrivacy = () => {
  return (
    <div className="terms-privacy-page">
      <Navigation />

      <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-6">
            <h1 className="font-serif text-4xl mb-4">Privacy Policy</h1>
            <div className="text-grayWarm max-w-3xl mx-auto text-left leading-relaxed">
              <p className="mb-4">Your privacy and trust are our top priorities. Here’s how we protect your personal information:</p>

              <ul className="list-disc list-inside mb-4">
                <li className="mb-2">We collect only the information necessary to provide and improve our astrology services, such as your name, contact details, and birth data.</li>
                <li className="mb-2">Your data is stored securely and never shared with third parties without your consent.</li>
                <li className="mb-2">We use your information solely for scheduling, session preparation, and communication related to your consultations.</li>
                <li className="mb-2">Our website uses cookies and analytics tools to enhance your experience, but no personally identifiable information is shared.</li>
                <li className="mb-2">You have the right to access, correct, or delete your personal data at any time by contacting us.</li>
              </ul>

              <p>For any questions about your privacy or how we handle your information, please reach out to us directly.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPrivacy;
